import * as React from 'react';
import {useState} from 'react';

import DropDown, {DropDownColor, DropDownOption, DropDownType} from '../../../shared/DropDown';
interface ShipByProps {
  onChange: (start: Date | null, end: Date | null, value: string) => void;
  initialValue?: string;
}

const ShipBy: React.FC<ShipByProps> = (props) => {
  const options = [
    {name: 'Anytime', value: 'anytime'},
    {name: 'Today', value: 'today'},
    {name: 'Today and Tomorrow', value: 'todayAndTomorrow'},
    {name: 'Today + 2 Days', value: 'todayPlusTwo'},
    {name: 'Today + 3 Days', value: 'todayPlusThree'},
    {name: 'Past Due', value: 'pastDue'}
  ];

  const selectedValue = options.find((option) => option.value === props.initialValue) || options[0];
  const [selectedOption, setSelectedOption] = useState<DropDownOption>(selectedValue);

  const today = new Date();
  const tOffsetDays = (offset: number) => {
    const d = new Date(today);
    d.setDate(d.getDate() + offset);
    return d;
  };
  const yesterday = tOffsetDays(-1);
  const tomorrow = tOffsetDays(1);
  const tPlusTwoDays = tOffsetDays(2);
  const tPlusThreeDays = tOffsetDays(3);

  const onSelect = (option: DropDownOption) => {
    switch (option.value) {
      case 'anytime':
        setSelectedOption(option);
        props.onChange(null, null, option.value);
        break;
      case 'pastDue':
        setSelectedOption(option);
        props.onChange(null, yesterday, option.value);
        break;
      case 'today':
        setSelectedOption(option);
        props.onChange(today, today, option.value);
        break;
      case 'todayAndTomorrow':
        setSelectedOption(option);
        props.onChange(today, tomorrow, option.value);
        break;
      case 'todayPlusTwo':
        setSelectedOption(option);
        props.onChange(today, tPlusTwoDays, option.value);
        break;
      case 'todayPlusThree':
        setSelectedOption(option);
        props.onChange(today, tPlusThreeDays, option.value);
        break;
      default:
        setSelectedOption(option);
        break;
    }
  };

  return (
    <div>
      <DropDown
        options={options}
        selected={selectedOption}
        color={DropDownColor.white}
        type={DropDownType.secondary}
        prefixText="Ship By:  "
        onSelect={onSelect}
      />
    </div>
  );
};

export default ShipBy;
